// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3mpeJ","name":"ConsentHeader_name__31SDn","birthday":"ConsentHeader_birthday__3OhUA","skeleton":"ConsentHeader_skeleton__3sJdA"};